import { AuthenticationAction, AuthToken } from "./types";
import { AuthenticationState } from "react-aad-msal";
import { AuthenticationActions } from "react-aad-msal";

const initialState: AuthToken = {
  initializing: false,
  initialized: false,
  idToken: "",
  accessToken: "",
  state: AuthenticationState.Unauthenticated,
  account: null
};
export function authenticationReducer(
  state = initialState,
  action: AuthenticationAction
): AuthToken {
  switch (action.type) {
    case AuthenticationActions.Initializing:
      return {
        ...state,
        initializing: true,
        initialized: false
      };
    case AuthenticationActions.Initialized:
      return {
        ...state,
        initializing: false,
        initialized: true
      };
    case AuthenticationActions.AcquiredIdTokenSuccess:
      return {
        ...state,
        idToken: action.payload.idToken
      };
    case AuthenticationActions.AcquiredAccessTokenSuccess:
      return {
        ...state,
        accessToken: action.payload.accessToken
      };
    case AuthenticationActions.AcquiredAccessTokenError:
      return {
        ...state,
        accessToken: ""
      };
    case AuthenticationActions.LoginSuccess:
      return {
        ...state,
        account: action.payload.account
      };
    case AuthenticationActions.LoginError:
    case AuthenticationActions.AcquiredIdTokenError:
    case AuthenticationActions.LogoutSuccess:
      return { ...state, idToken: "", accessToken: "", account: null };
    case AuthenticationActions.AuthenticatedStateChanged:
      return {
        ...state,
        state: action.payload.state
      };
    default:
      return state;
  }
}
